import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Button, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faQrcode } from '@fortawesome/free-solid-svg-icons';

// Componentes
import StatsHeader from './StatsHeader';
import MerchantCalendar from './MerchantCalendar';
import BookingFilters from './BookingFilters'; // <--- IMPORTAMOS FILTROS
import { getDashboardStats } from '../../../controllers/company/MerchantBookingController';
import ScanQrModal from './ScanQrModal';
import BookingDetailModal from './BookingDetailModal';
import NewBookingModal from './NewBookingModal';

export default function MerchantReservationsPage() {
    const [stats, setStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(true);
    
    // Estados para Modales
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showQrModal, setShowQrModal] = useState(false);
    
    // Estados para Filtros y Navegación
    const [calendarKey, setCalendarKey] = useState(0);
    const [currentDate, setCurrentDate] = useState(new Date()); // Fecha actual del calendario
    const [filters, setFilters] = useState({ employee_id: '', status: '' }); // Filtros activos
    const [resourcesList, setResourcesList] = useState([]); // Lista para llenar el select de filtros

    //nuevo cliente
    const [isOpenNewBookingModal,setIsOpenNewBookingModal] = useState(false);

    useEffect(() => {
        loadStats();
    }, [calendarKey]);

    const loadStats = async () => {
        setLoadingStats(true);
        const data = await getDashboardStats();
        if(data.success) setStats(data.data);
        setLoadingStats(false);
    };

    const refreshDashboard = () => {
        setCalendarKey(prev => prev + 1);
    };

    const handleEventClick = (event) => setSelectedEvent(event);

    const handleNewBooking = () => {
        setIsOpenNewBookingModal(!isOpenNewBookingModal);
    };

    const handleNewBookingSuccess = () => {

    }

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            
            {/* 1. Header & Actions */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h4" fontWeight="bold">
                    Dashboard de Reservas
                </Typography>
                
                <Stack direction="row" spacing={2}>
                    <Button 
                        variant="outlined" 
                        color="primary" 
                        startIcon={<FontAwesomeIcon icon={faQrcode} />}
                        onClick={() => setShowQrModal(true)}
                    >
                        Escanear Check-in
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        startIcon={<FontAwesomeIcon icon={faPlus} />}
                        onClick={handleNewBooking}
                    >
                        Nueva Cita
                    </Button>
                </Stack>
            </Box>

            <NewBookingModal
                open={isOpenNewBookingModal}
                onSuccess={handleNewBookingSuccess}
                onClose={handleNewBooking}
            />

            {/* 2. Estadísticas */}
            <StatsHeader stats={stats} loading={loadingStats} />

            {/* 3. BARRA DE FILTROS (NUEVO) */}
            <BookingFilters 
                date={currentDate}
                setDate={setCurrentDate}
                filters={filters}
                setFilters={setFilters}
                resources={resourcesList} // Pasamos la lista cargada por el calendario
            />

            {/* 4. Calendario */}
            <MerchantCalendar 
                key={calendarKey} 
                onEventClick={handleEventClick}
                
                // Props nuevas para control
                targetDate={currentDate} 
                filters={filters}
                onResourcesLoaded={setResourcesList} // El calendario nos avisa qué empleados hay
            />

            {/* 5. Modales */}
            {selectedEvent && (
                <BookingDetailModal 
                    open={!!selectedEvent} 
                    event={selectedEvent} 
                    onClose={() => setSelectedEvent(null)} 
                    onRefresh={refreshDashboard}
                />
            )}

            {showQrModal && (
                <ScanQrModal 
                    open={showQrModal} 
                    onClose={() => setShowQrModal(false)}
                    onScanSuccess={refreshDashboard}
                />
            )}

        </Container>
    );
}